import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {Session} from "../../../services/Session";
import {ToastService} from "../../../services/Toast.service";
import {LoadingService} from "../../../services/LoadingService";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";

@Component({
  selector: 'app-tax-strategy-potential-risks',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './tax-strategy-potential-risks.component.html',
  styleUrl: './tax-strategy-potential-risks.component.scss'
})
export class TaxStrategyPotentialRisksComponent implements OnInit, OnDestroy {
  @Input() taxStrategy: string;
  org: string =  Session.getOrg();
  user: string = Session.getUser().id;
  destroy$: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {}

  ngOnInit() {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFileData(file, isForVisualImage?){
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.downloadDocument(this.user, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (isForVisualImage) {
          file.temporaryURL = response.temporaryURL;
          file.fileType = 'image';
        } else {
          window.open(response.temporaryURL);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const errorMessage = (isForVisualImage) ? 'Failed to get image file document' : 'Failed to download document';
        this.toastService.pop(TOAST_TYPE.error, errorMessage);
      });
  }

}
